import React from 'react';
import { Paper } from '@mui/material';
import { Oval } from 'react-loader-spinner';
import propTypes from 'prop-types';

function SectionLoader({ height = 40 }) {
  return (
    <Paper className="d-flex align-items-center justify-content-center" sx={{ height: `${height}vh` }}>
      <Oval
        visible
        height="60"
        width="60"
        color="#259245"
        ariaLabel="grid-loading"
        radius="12.5"
        wrapperStyle={{}}
        wrapperClass="grid-wrapper"
      />
    </Paper>
  );
}

SectionLoader.propTypes = {
  height: propTypes.number,
};

export default SectionLoader;
